import React, { useCallback, useState } from 'react';
import dayjs from 'dayjs';
import { MenuItem, Select } from '@mui/material';
import { getTodayFilter } from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { updateTableState } from 'redux/slices/common/appSlice';

export const DateFilter = ({ setFilter, filter, disabled }: { setFilter?: any; filter?: any; disabled?: boolean }) => {
    const { pageNumber, ...tableState } = useSelector((state: RootState) => state.app.table);
    const [date, setDate] = useState('today');
    const dispatch = useDispatch();
    const handleChange = useCallback(
        (value: any) => {
            if (!setFilter) return;
            const resetTablePagination = { pageNumber: 0, offset: 0 };
            dispatch(updateTableState({ ...tableState, ...resetTablePagination }));
            switch (value) {
                case 'today': {
                    setFilter({
                        ...filter,
                        ...getTodayFilter(),
                        ...resetTablePagination,
                    });
                    break;
                }
                case 'yesterday': {
                    const startDate = dayjs().add(-1, 'day').startOf('day');
                    const endDate = dayjs().subtract(1, 'day').endOf('day');
                    setFilter({
                        ...filter,
                        dayFrom: startDate.format(),
                        dayTo: endDate.format(),
                        value: 'yesterday',
                        ...resetTablePagination,
                    });
                    break;
                }
                case 'thisMonth': {
                    const startDate = dayjs().startOf('month');
                    const endDate = dayjs();
                    setFilter({
                        ...filter,
                        dayFrom: startDate.format(),
                        dayTo: endDate.format(),
                        value: 'thisMonth',
                        ...resetTablePagination,
                    });
                    break;
                }
                case 'lastMonth': {
                    const startDate = dayjs().subtract(1, 'month').startOf('month');
                    const endDate = dayjs().subtract(1, 'month').endOf('month');
                    setFilter({
                        ...filter,
                        dayFrom: startDate.format(),
                        dayTo: endDate.format(),
                        value: 'lastMonth',
                        ...resetTablePagination,
                    });
                    break;
                }
                case 'all': {
                    setFilter({ ...tableState, ...resetTablePagination });
                    break;
                }
                default:
                    break;
            }
            setDate(value);
        },
        [setFilter, filter, tableState]
    );
    return (
        <Select
            disabled={disabled}
            value={date}
            onChange={(e) => handleChange(e.target.value)}
            sx={{
                width: 'auto',
                '& fieldset': {
                    border: 'none',
                },
            }}
        >
            <MenuItem value="today">Today</MenuItem>
            <MenuItem value="yesterday">Yesterday</MenuItem>
            <MenuItem value="thisMonth">This month</MenuItem>
            <MenuItem value="lastMonth">Last month</MenuItem>
            <MenuItem value="all">All</MenuItem>
        </Select>
    );
};
